import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AttendeesGuard } from './guards/attendees.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home-office',
  },
  {
    path: 'home-office',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/home-office/home-office.component').then(
        (c) => c.HomeOfficeComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'experiences-list',
      },
      { path: 'experiences-list', loadComponent: () => import('./pages/experience/experiences-list/experiences-list-page.component').then(m => m.ExperiencesListPageComponent) },
      { path: 'experiences', loadComponent: () => import('./pages/experience/experiences-page/experiences-page.component').then(m => m.ExperiencesPageComponent) },
      {
        path: 'attendees-list',
        loadComponent: () => import('./pages/attendees/attendees-list/attendees-list-page.component').then(m => m.AttendeesListPageComponent),
        canActivate: [AttendeesGuard]
      },
      { path: 'experience-detail', loadComponent: () => import('./pages/experience/experience-detail/experience-detail-page.component').then(m => m.ExperienceDetailPageComponent) },
      { path: 'notifications', loadComponent: () => import('./pages/notification/notification-list/notification-list.component').then(m => m.NotificationListComponent) },
      {
        path: 'add-attendees',
        loadComponent: () => import('./pages/attendees/add-attendees/add-attendees.component').then(m => m.AddAttendeesComponent),
        canActivate: [AttendeesGuard]
      },
      { path: 'events', loadComponent: () => import('./pages/events/event-list/event-list-page.component').then(m => m.EventListPageComponent) },
      {
        path: 'attendee-classification',
        loadComponent: () => import('./pages/attendee-classification/attendee-classification-page.component').then(m => m.AttendeeClassificationPageComponent),
        canActivate: [AttendeesGuard]
      }
    ]
  }

];

